import Layout from '@/layout'

const villageRouter = {
  path: '/periphery',
  component: Layout,
  children: [
    {
      path: '/periphery',
      name: 'periphery',
      meta: {
        title: '商品管理',
      },
      component: () => import('@/views/periphery/index.vue'),
    },
    {
      path: '/peripheryOrder',
      name: 'peripheryOrder',
      meta: {
        title: '商品订单',
      },
      component: () => import('@/views/periphery/peripheryOrder.vue'),
    },
    {
      path: '/peripheryEvaluate',
      name: 'peripheryEvaluate',
      meta: {
        title: '商品评价',
      },
      component: () => import('@/views/periphery/peripheryEvaluate.vue'),
    },
    {
      path: '/peripheryCategory',
      name: 'peripheryCategory',
      meta: {
        title: '商品类目',
      },
      component: () => import('@/views/periphery/peripheryCategory.vue'),
    },
  ],
}

export default villageRouter
